/* eslint-disable max-len */
import React from 'react';
import { ILeiMatka } from 'types/leiTypes';

import TableComponent from 'components/atoms/TableComponent';
import TranslateText from 'components/hoc/TranslateText';

import { ETypMatky } from 'enums/lei/leiDataEnums';

interface IProfondy {
    vsechnyMatky?: ILeiMatka[];
}

const Profondy: React.FC<IProfondy> = ({ vsechnyMatky }) => {
    const profondyMatky = vsechnyMatky?.filter(
        e =>
            e.typmatky !== ETypMatky.IS_ULTIMATELY_CONSOLIDATED_BY &&
            e.typmatky !== ETypMatky.IS_DIRECTLY_CONSOLIDATED_BY
    );

    const columns = [
        {
            title: <TranslateText>VZTAH</TranslateText>,
            dataIndex: 'typmatky',
            key: 'typmatky',
            render: (text: string) => (
                <p
                    style={{
                        margin: 0
                    }}
                >
                    <TranslateText>{`LEI_${text?.split('-').join('_')}`}</TranslateText>
                </p>
            )
        },
        {
            title: <TranslateText>LEI_FONDU</TranslateText>,
            dataIndex: 'matkaslei',
            key: 'matkaslei',
            render: (text: string) => (
                <p
                    style={{
                        margin: 0
                    }}
                >
                    {text}
                </p>
            )
        }
    ];

    return (
        <>
            <TableComponent
                rowKey={(_, index) => index || 0}
                locale={{
                    emptyText: <TranslateText>LEI_FOND_NENI</TranslateText>
                }}
                style={{
                    margin: '30px 0px'
                }}
                columns={columns}
                dataSource={profondyMatky}
                pagination={false}
            />
        </>
    );
};

export default Profondy;
